import React from "react";
import "./index.scss";
import CircularProgress from "@mui/material/CircularProgress";

function Loader({ loadingText }) {
  return (
    <div className="loader absolute width-100 height-100 flex center">
      <div className="content">
        <CircularProgress size={60} />
        {loadingText}
      </div>
    </div>
  );
}

export default Loader;
